var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',[_c('Paper',{staticClass:"favorite-card-root p-4 pointer d-flex flex-column align-items-center"},[_c('div',{staticClass:"image-wrapper"},[_c('Avatar')],1),_c('Row'),_c('Row')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }